module.exports = __webpack_public_path__ + "static/media/sas.f589ab1b.svg";